
import Vue from "vue"
export default Vue.extend({
   components:{
	
   },
   methods:{
	  handleClick(){
		// console.log("click");
		this.$emit('click')
		
	  }
   }
})
